/**
 * Created by Jerker Nord on 2020-08-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineLite, TweenLite} from "gsap";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {MonkeysGoldReelSymbol} from "../../symbols/MonkeysGoldReelSymbol";

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomBounce.js");

export class MonkeysGoldBigSymbolLandView extends BaseView {

    private _wildsDropTL:TimelineLite;
    private _bigSymbolDropTL:TimelineLite;
    private _bigSymbolLanded:boolean = false;

    constructor() {
        super();
        CustomBounce.create("shakeBounce", {strength : 0.8, squash : 0, endAtStart : true, squashID : "shake"});
        CustomEase.create("spinStopEase", "M0,0,C0.058,0.259,0.104,0.494,0.212,0.654,0.33,0.83,0.172,0.959,0.312,1,0.352,1.01,0.377,1.008,0.456,0.99,0.515,0.975,0.624,0.982,0.668,0.982,0.706,0.982,0.67,0.998,0.684,1,0.706,1.002,0.943,1,1,1");
    }

    protected initAnimations() {
        this._wildsDropTL = new TimelineLite();
    }

    public playBigSymbolLandAnimation(bigSymbolSize:number, symbol:StateReelSymbol):TimelineLite {
        if(this._bigSymbolDropTL && this._bigSymbolDropTL.isActive()) {
            this._bigSymbolDropTL.pause();
            this._bigSymbolDropTL.kill();
        }
        this._bigSymbolDropTL = new TimelineLite();
        this._bigSymbolDropTL.add(() => this._bigSymbolLanded = true);
        this._bigSymbolDropTL.add([
            TweenLite.to(StageManager.stage, 0.2, {
                y : "+=" + (5 * bigSymbolSize),
                ease : "shakeBounce"
            }),
            () => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.BIG_SYMBOL_LANDING)})
        ]);
        if(bigSymbolSize == 3 || (bigSymbolSize == 2 && (<MonkeysGoldReelSymbol>symbol).bigSymbolMultiplier > 9)) {
            this._bigSymbolDropTL.add(() => (<MonkeysGoldReelSymbol>symbol).playMultiplierTextLandAnimation());
        } else {
            (<MonkeysGoldReelSymbol>symbol).multiplierText.visible = true;
        }
        return this._bigSymbolDropTL;
    }

    get wildsDropTL():TimelineLite {
        if(this._wildsDropTL && this._wildsDropTL.isActive()) {
            this._wildsDropTL.pause();
            this._wildsDropTL.kill();
        }
        this._wildsDropTL = new TimelineLite();

        if(this._bigSymbolLanded == false) {
            return this._wildsDropTL;
        } else {
            this._bigSymbolLanded = false;
        }

        let numberOfWilds:number = 0;
        const subWildTLs:TimelineLite[] = [];
        for(let i:number = 0; i < 6; i++) {
            let symbolsOnReel:StateReelSymbol[] = Reels.getReel(i)!.allSymbols;
            if(symbolsOnReel) {
                for(let j:number = 0; j < symbolsOnReel.length; j++) {
                    if(symbolsOnReel[j].symName == "W_hidden") {
                        numberOfWilds++;
                    }
                }
                let wildCounter:number = 0;
                for(let j:number = symbolsOnReel.length - 1; j > -1; j--) {
                    if(symbolsOnReel[j].symName == "W_hidden") {
                        const subwildTL:TimelineLite = new TimelineLite();
                        subwildTL.add(() => wildCounter++);
                        subwildTL.add(() => symbolsOnReel[j].position.y -= (GameConfig.instance.SYMBOL_HEIGHT * numberOfWilds));
                        subwildTL.add(() => symbolsOnReel[j].replaceWith("W", j));
                        subwildTL.add([
                            TweenLite.to(symbolsOnReel[j].position, 0.4, {
                                y : symbolsOnReel[j].position.y,
                                ease : "spinStopEase"
                            }),
                            () => {
                                subwildTL.add(() => TweenLite.to(StageManager.stage, 0.2, {
                                    y : "+=" + 2,
                                    ease : "shakeBounce"
                                }), "-=0.2");
                                subwildTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.WILD_LANDING)}), "-=0.2");
                            }
                        ]);

                        subwildTL.add(() => numberOfWilds--);
                        this._wildsDropTL.add(subwildTL, "-=0.2");
                    }
                }
            }
        }
        this._wildsDropTL.add(subWildTLs, "-=0.1");
        return this._wildsDropTL;
    }

    public resetWildDropTL():void {

    }
}